import { Assistant, ChatMessage, SuggestedAction, SuggestedActionType } from "../../../shared/models";
import { Suggestions } from "../components/suggestions";
import { useMemo } from "react";

interface UseSuggestedActionsProps {
    sendMessage: (message: string) => void;
    assistant?: Assistant;
    handleSessionComplete: () => void;
}

export const useSuggestedActions = ({
    sendMessage,
    assistant,
    handleSessionComplete
}: UseSuggestedActionsProps) => {
    const renderSuggestions = useMemo(() => (message: ChatMessage) => {
        if (!message.showSuggestions) {
            return null;
        }
        if (!assistant) {
            return null;
        }

        const suggestions: SuggestedAction[] = [];
        if (message.completed) {
            const { show_exit_button, exit_button_caption, show_your_chat_button, your_chat_button_caption } = assistant;
            if (show_exit_button) {
                suggestions.push({ action: SuggestedActionType.Exit, content: exit_button_caption || "Exit" });
            }
            if (show_your_chat_button) {
                suggestions.push({ action: SuggestedActionType.YourChat, content: your_chat_button_caption || "Your chat" });
            }
            // Always add "More On This" for completed sessions
            suggestions.push({ action: SuggestedActionType.MoreOnThis, content: "More On This" });
        }
        return (
            <Suggestions
                suggestions={suggestions?.length ? suggestions : message.suggestions || []}
                sendMessage={sendMessage}
                handleSessionComplete={handleSessionComplete}
                assistantName={assistant?.display_name || assistant?.name}
            />
        );
    }, [assistant, sendMessage]);

    return { renderSuggestions };
}; 